import React from 'react';
import moment from 'moment';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './DateSelector.module.css';
import { CalendarIcon } from '../../icons';
import { DATE_FORMAT } from '../../constants';

const DateSelector = ({ activeDate, dates, handleDateSelect, classNames,agsn }) => {

  const asnTextChangeCall =()=>{
    if(agsn?.length > 0)      
        return 'AGSN Creation: Pending..';      
      else
        return 'ASN Creation: Pending..';      
  }

  const getMonthString = activeDate => {
    const yesterday = moment().subtract(1, 'days');
    if (activeDate.isSame(yesterday, 'days')) return moment().format('MMMM');
    return activeDate.format('MMMM');
  };
  return (
    <>
      <CalendarIcon className={styles.calendarIcon} />
      <div className={styles.monthRgt}>
        <span className={clsx(styles.monthName, classNames?.monthName)}>
          {activeDate ? getMonthString(activeDate) : asnTextChangeCall()}
        </span>
        <div className={styles.hrScroll}>
          <div className={styles.datesRow}>
            {dates.map(date => (
              <button
                className={
                  date === activeDate || date.isSame(activeDate, 'day')
                    ? clsx(
                        styles.activeDateButton,
                        classNames?.activeDateButton,
                      )
                    : clsx(
                        styles.datesSelectorButton,
                        classNames?.datesSelectorButton,
                      )
                }
                onClick={() => handleDateSelect(date)}
                key={date}
                aria-label={`select-date-${date.format(DATE_FORMAT.ISO)}`}
              >
                {date.format('DD')}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

DateSelector.propTypes = {
  activeDate: PropTypes.objectOf(moment),
  dates: PropTypes.arrayOf(PropTypes.objectOf(moment)),
  handleDateSelect: PropTypes.func.isRequired,
  classNames: PropTypes.shape({
    activeDateButton: PropTypes.string,
    datesSelectorButton: PropTypes.string,
    monthName: PropTypes.string,
  }),
  agsn : PropTypes.string,
};

export default DateSelector;
